module.exports = __webpack_public_path__ + "img/5.767414a1.jpg";